import { PageHeader, Stack, t } from '@kanbios/ui';
import { Shell } from '../../components/Shell';
import { AddressTable } from '../../components/domains/AddressTable';
import { useFillHeight } from '../../lib/useFillHeight';
import { DomainsTabs } from './DomainsTabs';

/** Domaines (D27), DSM index page: every address the servers serve or the catalogue declares. */
export function AddressesPage() {
  const fill = useFillHeight();
  return (
    <Shell crumbs={[{ label: t('nav.domains') }]}>
      <Stack gap={24}>
        <PageHeader title={t('nav.domains')} subtitle={t('addresses.subtitle')} />
        <DomainsTabs value="addresses" />
        <div ref={fill[0]}>
          <AddressTable height={fill[1]} />
        </div>
      </Stack>
    </Shell>
  );
}
